export default "__VITE_ASSET__D_5YeS_b__"